
import { Github, Linkedin, Mail } from 'lucide-react'
import { profile } from '@/data/profile'

const getSocialLinks = () => [
  {
    name: 'GitHub',
    href: profile.github,
    icon: <Github className="h-5 w-5" />,
  },
  {
    name: 'LinkedIn',
    href: profile.linkedin,
    icon: <Linkedin className="h-5 w-5" />,
  },
  {
    name: 'Email',
    href: `mailto:${profile.email}`,
    icon: <Mail className="h-5 w-5" />,
  },
]

export function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="border-t border-border-light dark:border-border-dark bg-white/50 dark:bg-bg-dark/50 backdrop-blur-sm">
      <div className="container-max section-padding">
        <div className="py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Brand */}
            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-text-light dark:text-text-dark">
                {profile.name}
              </h3>
              <p className="text-sm text-text-light/70 dark:text-text-dark/70 max-w-xs">
                {profile.bio}
              </p>
            </div>

            {/* Quick Links */}
            <div className="space-y-4">
              <h4 className="text-sm font-semibold text-text-light dark:text-text-dark uppercase tracking-wider">
                Quick Links
              </h4>
              <div className="space-y-2">
                {['About', 'Skills', 'Projects', 'Contact'].map((item) => (
                  <a
                    key={item}
                    href={`#${item.toLowerCase()}`}
                    className="block text-sm text-text-light/70 dark:text-text-dark/70 hover:text-accent transition-colors"
                  >
                    {item}
                  </a>
                ))}
              </div>
            </div>

            {/* Social Links */}
            <div className="space-y-4">
              <h4 className="text-sm font-semibold text-text-light dark:text-text-dark uppercase tracking-wider">
                Connect
              </h4>
              <div className="flex space-x-4">
                {getSocialLinks().map((link) => (
                  <a
                    key={link.name}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 rounded-lg border border-border-light dark:border-border-dark text-text-light/70 dark:text-text-dark/70 hover:text-accent hover:border-accent/30 transition-all duration-200"
                    aria-label={link.name}
                  >
                    {link.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Bottom section */}
          <div className="mt-12 pt-8 border-t border-border-light dark:border-border-dark">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <p className="text-sm text-text-light/60 dark:text-text-dark/60">
                © {currentYear} {profile.name}. All rights reserved.
              </p>
              
              {/* Now line */}
              <div className="flex items-center space-x-2 text-sm text-text-light/60 dark:text-text-dark/60">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                <span>Available for opportunities</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
